module.exports = __webpack_public_path__ + "img/icon_jd.4a836b53.png";